import { Injectable } from '@angular/core'
import { GbActivityFeedToggleService } from 'libs/gb-front/activity-feed/util/src/lib/activity-feed-toggle.service'
import { GbAuctionBannerVisibilityService } from 'libs/gb-front/auction/util/src/lib/gb-auction-banner-visibility/gb-auction-banner-visibility.service'
import { GbAuctionFooterVisibilityService } from 'libs/gb-front/auction/util/src/lib/gb-auction-footer-visibility/gb-auction-footer-visibility.service'
import { GbAuctionMenuToggleVisibilityService } from 'libs/gb-front/auction/util/src/lib/gb-auction-menu-toggle-visibiliy/gb-auction-menu-toggle-visibility.service'
import { Observable, take } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbDetailShowHideService {
  constructor(
    private gbAuctionFooterVisibilityService: GbAuctionFooterVisibilityService,
    private gbBannerVisibilityService: GbAuctionBannerVisibilityService,
    private gbAuctionMenuToggleVisibilityService: GbAuctionMenuToggleVisibilityService,
    private gbActivityFeedToggleService: GbActivityFeedToggleService,
  ) {}

  hideOnInit(isSingleItem$: Observable<boolean>): void {
    this.hideBannerandFooter()
    this.hideToggleButton(isSingleItem$)
    this.gbActivityFeedToggleService.hideActivityFeed()
  }

  showOnDestroy(): void {
    this.gbAuctionMenuToggleVisibilityService.showToggleButton()
    this.gbActivityFeedToggleService.showActivityFeed()
    this.gbAuctionFooterVisibilityService.showFooter()
    this.gbBannerVisibilityService.showBanner()
  }

  // A resolving promise is needed here as the hideFooter and hide banner functions need to
  // occur asynchronously. This is because they will update values on the parent component
  // (GbAuctionComponent) after angular has run the change detection checks.

  private hideBannerandFooter(): Promise<void> {
    return Promise.resolve().then(() => {
      this.gbAuctionFooterVisibilityService.hideFooter()
      this.gbBannerVisibilityService.hideBanner()
    })
  }

  private hideToggleButton(isSingleItem$: Observable<boolean>): void {
    isSingleItem$.pipe(take(1)).subscribe((isSingleItem) => {
      if (!isSingleItem) this.gbAuctionMenuToggleVisibilityService.hideToggleButton()
    })
  }
}
